import React from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogContentText,
    DialogActions, Button
} from '@mui/material';

// ============================================================
// ConfirmDialog — reusable confirmation modal
// Usage:
//   <ConfirmDialog
//     open={open}
//     title="Supprimer l'offre?"
//     message="Cette action est irréversible."
//     onConfirm={handleDelete}
//     onCancel={() => setOpen(false)}
//   />
// ============================================================

export default function ConfirmDialog({
    open, title, message,
    onConfirm, onCancel,
    confirmText = 'Confirmer',
    confirmColor = 'error',
}) {
    return (
        <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                <DialogContentText>{message}</DialogContentText>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2 }}>
                <Button onClick={onCancel} variant="outlined">Annuler</Button>
                <Button onClick={onConfirm} variant="contained" color={confirmColor}>
                    {confirmText}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
